export function ImageIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12C8.895 12 8 12.895 8 14v38c0 1.105.895 2 2 2h44c1.105 0 2-.895 2-2V14c0-1.105-.895-2-2-2H10Z"
        fill="currentColor"
        opacity="0.15"
      />
      <path
        d="M10 12C8.895 12 8 12.895 8 14v38c0 1.105.895 2 2 2h44c1.105 0 2-.895 2-2V14c0-1.105-.895-2-2-2H10Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle cx="20" cy="24" r="4" fill="currentColor" opacity="0.4" />
      <path
        d="M8 42l12-10 10 10 10-12 16 14v8c0 1.105-.895 2-2 2H10c-1.105 0-2-.895-2-2v-10Z"
        fill="currentColor"
        opacity="0.3"
      />
    </svg>
  )
}
